/** * create 2023-06-05 * author siwenqiang */
<template>
  <div class="actual-combat">
    <h2 class="title">项目实战全记录</h2>
    <div class="tab-box">
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in actualCombatData"
          :key="index"
          :label="item.title"
          :name="String(index)"
        >
          <div class="item-content">
            <div class="video">
              <div
                class="item-img"
                :style="{ backgroundImage: `url(${item.image[0].url}) ` }"
              ></div>
              <img :src="item.image[0].url" class="item-img" />
              <div class="hover"></div>
              <img
                v-if="item.url"
                :class="`play-btn${index} item-btn`"
                @click="play(index, item.url)"
                src="../aiImg/btn_play@2x.png"
              />
            </div>
            <div class="content">
              <div>
                <div class="title">{{ item.subTitle }}</div>
                <div class="paragraph">
                  {{ item.desc }}
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <MenuAdd ref="editMenu"></MenuAdd>
  </div>
</template>
<script>
import MenuAdd from "../../../../components/video.vue";
export default {
  name: "actualCombat",
  components: {
    MenuAdd,
  },
  props: {
    actualCombatData: [],
  },
  data() {
    return {
      activeName: 0,
    };
  },
  methods: {
    handleClick() {},
    play(index, url) {
      // document.getElementById(`videoPlayer${index}`).play();
      // document.querySelector(`.play-btn${index}`).style.display = 'none';
      this.$refs.editMenu.dialogFormV({ pVideoUrl: url });
    },
  },
};
</script>
<style lang="scss" scoped>
.actual-combat {
  padding: 0 12%;
  margin-top: 70px;
  .title {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: #19232b;
    margin-bottom: 35px;
  }
  .tab-box {
    .el-tabs {
      margin: 0px;
      :deep(.el-tabs__header) {
        margin-bottom: 40px !important;
      }
      :deep(.el-tabs__nav-wrap::after) {
        background-color: #e4e7ed !important ;
      }
      :deep(.el-tabs__item.is-active) {
        color: #409eff !important;
        background: none !important;
      }
      :deep(.el-tabs__item) {
        background-color: transparent;
        height: 40px !important;
        line-height: 40px !important;
        margin-right: 0px;
        padding: 0 50px;
        font-size: 18px;
        color: #19232b;
        font-family: PingFangSC-Medium;
        margin-bottom: 10px;
      }
      :deep(.el-tabs__active-bar) {
        display: block;
      }
      :deep(.el-tabs__nav-scroll) {
        display: flex;
        justify-content: center;
      }
    }
    .item-content {
      display: flex;
      height: 340px;
      .content > div {
        padding: 74px 53px 0 51px;
      }
      .content {
        background-image: linear-gradient(224deg, #49ccff 0%, #1f80ff 100%);
        flex-basis: 0;
        flex-grow: 1;

        .title {
          text-align: left;
          font-size: 28px;
          color: white;
          font-weight: 500;
        }
        .paragraph {
          font-size: 14px;
          color: rgba($color: #fff, $alpha: 0.8);
          font-weight: normal;
          line-height: 30px;
        }
      }
      .video:hover {
        .javaVideo {
          transform: scale(1.1);
          transition: all 0.8s;
        }
      }
      .video {
        flex-basis: 0;
        flex-grow: 1;
        position: relative;
        .hover {
          width: 100%;
          background-color: #081023;
          opacity: 0.1;
          height: 100%;
          position: absolute;
          left: 0;
          top: 0;
        }
        .javaVideo {
          height: 340px;
          width: 100%;
        }
        .item-btn {
          position: absolute;
          left: 50%;
          transform: translateX(-53px) translateY(-53px);
          top: 50%;
          width: 106px;
          height: 106px;
          cursor: pointer;
        }
        .item-img {
          width: 100%;
          height: 100%;
          background-size: cover;
          background-repeat: no-repeat;
          background-position: center;
        }
      }
    }
  }
}
</style>
